import React from "react";
import MechanicRotor from '../images/MechanicRotor.jpg';

export const About = () => {
    return (
        <section className='about-section' id='about'>
            <div className='section-content'>

                <div className='about-details'>
                    <h2 className='section-title'>
                        About Us
                    </h2>

                    <p className='about-text'>
                    We provide a complete range of professional auto repair and maintenance services to keep your vehicle performing at its best. From engine diagnostics, brake repairs, suspension, steering, and transmission services to A/C repairs, electrical diagnostics, batteries, alternators, radiators, and preventative maintenance, our experienced technicians are ready to help. We also specialize in collision repair, auto body work, professional painting, vehicle inspections, and much more—all backed by quality workmanship and honest service.
                    </p>

                    <div className='about-stats'>
                        <div className='about-stat-card'>
                            <p className='about-stat-number'>100+</p>
                            <p className='about-stat-label'>Happy Clients</p>
                        </div>

                        <div className='about-stat-card'>
                            <p className='about-stat-number'>10+</p>
                            <p className='about-stat-label'>Years Experience</p>
                        </div>
                    </div>
                </div>

                <div className='about-image-wrapper'>
                    <img src={MechanicRotor} alt='Mechanic performing electrical diagnostics under the hood' className='about-image'/>
                </div>
            </div>
        </section>
    )
}
